import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border border-zinc-800 rounded-xl overflow-hidden" data-id="element-69">
      <button onClick={onClick} className="w-full flex items-center justify-between p-5 text-left bg-zinc-900/50 hover:bg-zinc-900 transition-colors" aria-expanded={isOpen} data-id="element-70">
        <span className="text-white font-semibold pr-4" data-id="element-71">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-zinc-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-72" />
      </button>
      <AnimatePresence data-id="element-73">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-74">
            <div className="p-5 bg-zinc-900/30 border-t border-zinc-800" data-id="element-75">
              <p className="text-zinc-400" data-id="element-76">{answer}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Funciona en mi celular?',
    answer: 'Si tu celular tiene Android, funciona. La guía cubre desde modelos básicos hasta los más nuevos. Solo necesitas Android 5.0 o superior.'
  }, {
    question: '¿Y si mi Smart TV no es Android?',
    answer: 'La guía incluye métodos alternativos para Fire TV Stick, Chromecast con Google TV y otros dispositivos. También explicamos cómo usar tu celular para transmitir a cualquier TV.'
  }, {
    question: '¿Es complicado de seguir?',
    answer: 'Si puedes seguir instrucciones en orden, puedes instalarlo. Cada paso tiene captura de pantalla real. No necesitas saber de tecnología, solo seguir la guía.'
  }, {
    question: '¿Y si no me funciona?',
    answer: 'Garantía del 100% de devolución. Sin preguntas. Si seguiste todos los pasos y no funcionó, te devolvemos tu dinero completo.'
  }, {
    question: '¿Está actualizado?',
    answer: 'Sí. Versión 2025 con el APK y método de instalación vigente. Actualizamos la guía cada vez que hay cambios importantes.'
  }, {
    question: '¿Es legal?',
    answer: 'La guía te enseña a instalar la aplicación de forma técnica. El uso responsable y legal es decisión del usuario conforme a las leyes de su país.'
  }];
  return <section className="bg-gradient-to-b from-zinc-950 to-zinc-900 py-16 sm:py-24" data-id="element-77">
      <div className="max-w-3xl mx-auto px-4" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-79">
          <HelpCircleIcon className="w-10 h-10 text-emerald-400 mx-auto mb-4" data-id="element-80" />
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4" data-id="element-81">
            Preguntas <span className="text-emerald-400" data-id="element-82">Frecuentes</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-3" data-id="element-83">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-84" />)}
        </motion.div>
      </div>
    </section>;
}